"use client"

import { useState } from "react"
import CursoForm from "../components/Cursos/CursoForm"
import CursoList from "../components/Cursos/CursoList"
import "../styles/CursosPage.css"

export default function CursosPage() {
  const [updateList, setUpdateList] = useState(false)
  const [cursoParaEditar, setCursoParaEditar] = useState(null)

  const handleAdded = () => {
    setUpdateList((prev) => !prev)
    setCursoParaEditar(null)
  }

  const handleEdit = (curso) => {
    setCursoParaEditar(curso)
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const handleCancelEdit = () => {
    setCursoParaEditar(null)
  }

  return (
    <div className="cursos-page">
      <h1 className="page-title">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
          <path d="M6 12v5c3 3 9 3 12 0v-5"></path>
        </svg>
        Gestão de Cursos
      </h1>

      <CursoForm onAdded={handleAdded} cursoParaEditar={cursoParaEditar} onCancelEdit={handleCancelEdit} />

      <CursoList keyProp={updateList} onEdit={handleEdit} />
    </div>
  )
}
